import styles from './Environments.module.scss';
import { EnvironmentList } from './components/EnvironmentList/EnvironmentList';

export const Environments = () => {
  return (
    <div className={styles.wrapper}>
      <EnvironmentList/>
    </div>
  )
}
